import React from 'react';
import { motion } from 'framer-motion';
import { FaFacebook, FaTwitter, FaInstagram, FaLinkedin, FaGithub } from 'react-icons/fa';
import Logo from './Logo';

const Footer = () => {
  const socialLinks = [
    //{ icon: <FaFacebook />, href: '#' },
    //{ icon: <FaTwitter />, href: '#' },
      { icon: <FaInstagram />, href: 'https://www.instagram.com/platypusbox' },
      { icon: <FaLinkedin />, href: 'https://www.linkedin.com/company/platypusbox' },
    //{ icon: <FaGithub />, href: '#' }
  ];

  const footerLinks = [
    {
      title: 'Company',
      links: [
        { name: 'About', href: '#about' },
        { name: 'Services', href: '#services' },
        { name: 'Our Solutions', href: '#solutions' },
        { name: 'Solutions Platform', href: 'https://solutions.platypusbox.com' },
        { name: 'Contact', href: '#contact' }
      ]
    },
    {
      title: 'Resources',
      links: [
        //{ name: 'Blog', href: '#' },
        //{ name: 'Documentation', href: '#' },
        { name: 'Support', href: '#' },
        //{ name: 'Privacy Policy', href: '#' }
      ]
    }
  ];

  return (
    <footer className="bg-forest relative">
      {/* Top Wave */}
      <div className="absolute top-0 left-0 w-full overflow-hidden">
        <svg
          viewBox="0 0 1200 120"
          preserveAspectRatio="none"
          className="relative block w-full h-16"
          style={{ transform: 'rotate(180deg)' }}
        >
          <path
            d="M0,0V46.29c47.79,22.2,103.59,32.17,158,28,70.36-5.37,136.33-33.31,206.8-37.5C438.64,32.43,512.34,53.67,583,72.05c69.27,18,138.3,24.88,209.4,13.08,36.15-6,69.85-17.84,104.45-29.34C989.49,25,1113-14.29,1200,52.47V0Z"
            className="fill-[#AD9380]"
          />
        </svg>
      </div>

      <div className="container mx-auto px-4 pt-24 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          {/* Logo and Social */}
          <div className="col-span-1 md:col-span-2">
            <Logo className="w-48 mb-6" />
            <p className="text-cream/80 mb-6">
              Transforming ideas into exceptional digital experiences through innovative development solutions.
            </p>
            <div className="flex space-x-4">
              {socialLinks.map((social, index) => (
                <motion.a
                  key={index}
                  href={social.href}
                  className="text-cream hover:text-accent-green transition-colors text-xl"
                  whileHover={{ scale: 1.1 }}
                  whileTap={{ scale: 0.95 }}
                >
                  {social.icon}
                </motion.a>
              ))}
            </div>
          </div>

          {/* Links */}
          {footerLinks.map((section, index) => (
            <div key={index}>
              <h3 className="text-accent-green font-semibold mb-4">
                {section.title}
              </h3>
              <ul className="space-y-2">
                {section.links.map((link, linkIndex) => (
                  <li key={linkIndex}>
                    <a
                      href={link.href}
                      target={link.href.startsWith('http') ? '_blank' : undefined}
                      rel={link.href.startsWith('http') ? 'noopener noreferrer' : undefined}
                      className="text-cream/80 hover:text-accent-green transition-colors"
                    >
                      {link.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Copyright */}
        <div className="pt-8 border-t border-cream/10 text-center text-cream/60">
          <p> {new Date().getFullYear()} PlatypusBox. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
